import React from 'react';
const painPoints = ['El domingo a las 23:00 estás juntando apuntes de 5 compañeros distintos que no coinciden entre sí, y mañana tenés parcial de Anatomía.', 'Llegás a la cursada de Semiología y no sabés cómo arrancar la historia clínica frente al paciente. Y eso se nota.', 'Estudiás horas y horas pero en el examen se te va todo porque nunca tuviste el contenido ordenado de forma que tenga sentido.', 'Buscás información de Farmacología en 10 lugares diferentes y cada fuente te da un dato distinto. No sabés cuál usar.', 'Tus resúmenes los armás desde cero cada vez, sin un modelo claro, sin saber si estás estudiando lo que el docente realmente toma.', 'Estás en los años clínicos y todavía no tenés claro cómo se conectan todas las materias entre sí. La carrera se siente como piezas sueltas.'];
export function PainPoints() {
  return <section className="w-full px-4 sm:px-6 lg:px-8 py-10 text-gray-900 text-base leading-6 relative" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(254,242,242) 0%, rgb(254,242,242) 15%, rgb(254,242,242) 85%, rgb(255,255,255) 100%)'
  }} data-id="element-219">
      <div className="mx-auto max-w-4xl" data-id="element-220">

        {/* Section Title */}
        <p className="text-center text-xs sm:text-sm font-bold tracking-[2px] uppercase text-red-500 mb-2" data-id="element-221">
          ¿Te sentís identificado?
        </p>
        <h2 className="text-center text-2xl sm:text-3xl font-black text-gray-900 m-0 mb-2" data-id="element-222">
          Esto le pasa al 90% de los estudiantes de Medicina
        </h2>
        <p className="text-center text-sm text-gray-500 m-0 mb-6" data-id="element-223">
          No es falta de inteligencia. Es falta de un sistema de estudio real.
        </p>

        {/* Pain Points Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-8" data-id="element-224">
          {painPoints.map((point, i) => <div key={i} className="flex items-start gap-2 bg-white border border-red-200 rounded-lg p-3 shadow-sm" data-id="element-225">
              <span className="text-red-500 text-base leading-5 shrink-0" data-id="element-226">
                ✗
              </span>
              <p className="text-xs sm:text-sm text-gray-800 m-0" data-id="element-227">{point}</p>
            </div>)}
        </div>

        {/* Bottom CTA */}
        <p className="text-center text-xl sm:text-2xl font-black m-0 mb-6" style={{
        color: '#0284c7'
      }} data-id="element-228">
          ¿Cuántos parciales más vas a improvisar?
        </p>

        {/* Divider */}
        <div className="h-px w-full" style={{
        backgroundImage: 'linear-gradient(to right, rgba(255,255,255,0), rgb(14,165,233), rgba(255,255,255,0))'
      }} data-id="element-229" />
      </div>

      {/* Degradé de integración con ProductShowcase */}
      <div className="absolute bottom-0 left-0 right-0 h-16 pointer-events-none" style={{
      background: 'linear-gradient(to bottom, transparent 0%, rgb(240,249,255) 100%)'
    }} data-id="element-230" />
    </section>;
}